import { target } from '@github/catalyst';
import { controller } from '../controller';
import { dispatchChange } from '../util';

@controller('select-pdf-templates')
export class SelectPdfTemplatesElement extends HTMLElement {
  @target declare form: HTMLFormElement;

  selectTemplates(event: Event) {
    const target = event.target as HTMLButtonElement;
    const selectAll = target.dataset.select === 'all';
    const checkboxes = this.form.elements.namedItem(
      'template'
    ) as RadioNodeList;
    for (const checkbox of checkboxes) {
      if (!(checkbox instanceof HTMLInputElement)) {
        throw new Error('Expected HTMLInputElement');
      }
      checkbox.checked = selectAll && !checkbox.disabled;
      dispatchChange(checkbox);
    }
  }

  filterTemplates(event: Event) {
    const target = event.target as HTMLButtonElement;
    const label = target.dataset.filterLabel!.toLowerCase();
    target.parentElement?.querySelectorAll('[aria-current]').forEach(el => {
      el.removeAttribute('aria-current');
    });
    target.setAttribute('aria-current', 'true');
    const checkboxes = this.form.elements.namedItem(
      'template'
    ) as RadioNodeList;
    for (const checkbox of checkboxes) {
      if (!(checkbox instanceof HTMLInputElement)) {
        throw new Error('Expected HTMLInputElement');
      }
      const visible =
        label === 'all' ||
        checkbox.dataset.labels?.toLowerCase().split(',').includes(label);
      if (!visible && checkbox.checked) {
        checkbox.checked = false;
        dispatchChange(checkbox);
      }
      checkbox.closest('label')?.toggleAttribute('hidden', !visible);
    }
  }
}
